var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('height:'+_vm.innerHeight1+ 'px;width: '+_vm.innerW+'px;'),attrs:{"id":"app"}},[_c('vue-scroll',{ref:"vs",attrs:{"ops":_vm.ops}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }